<template>
  <div>
    <h4>PRESETS</h4>
    <a class="btn btn-primary mr-2" href="/booking-quote/airportparking-results?agent=ONLINE&category=airportparking&params=%5B%5D&airportA=1&dateA=2019-11-23&timeA=12%3A00&dateB=2019-11-27&timeB=12%3A00&promo=COMPARE&referrer=https://www.skyparksecure.com">parking</a>
    <a class="btn btn-primary mr-2" href="/booking-quote/airporthotel-results?agent=HOTPARK&passengers=1&category=airporthotel&params=%5B%5D&airportA=1&dateA=2019-11-23&timeA=12%3A00&timeB=12%3A00&dateB=2019-11-26&room1=1">hotels</a>
    <a class="btn btn-primary mr-2" href="/booking-quote/airportlounge-results?agent=Lounges&passengers=1&category=airportlounge&params=%5B%5D&terminal=&airportA=1&dateA=2020-01-23&_dateA=Mon%2C+18%2F11%2F19&dateB=2019-11-05&timeA=12%3A00&timeB=12%3A00&adults=1&children=0&infants=0">lounges</a>
    <a class="btn btn-primary mr-2" href="/booking-quote/affiliate/APS/airportparking/1/514/2019-11-02/12:00/2019-11-09/13:00">affiliate</a>
  </div>  
</template>

<script>
import { get, call } from "vuex-pathify";

export default {
  name: "quote",
  data() {
    return {
      params: null,
      results: [
        'airportparking',
        'airporthotel',
        'airportlounge'
      ],
    }
  },
  computed: {
    quote: get("quote")
  },
  methods: {
    updateQuote: call("quote/updateQuote"),
    clearQuote: call("quote/clearQuote"),
  },
  created() {

    // serialize
    this.params = JSON.stringify(this.$route.query);

    // check for params
    if(Object.keys(this.$route.query).length > 0) {

      this.clearQuote();

      // parse and push to store
      this.updateQuote(JSON.parse(this.params)).then(() => {

        // if the category is valid, push user to results page
        if(this.results.indexOf(this.quote.category) > -1) {
          this.$router.replace(`/${this.quote.category}-results`);
        }
      });

    } else {
      this.$router.replace(`/airportparking-results`);
    }
  }
};
</script>

